import React, {
  useRef,
  useEffect,
  useCallback,
  useLayoutEffect,
  useState,
} from "react";
import axios from "axios";
import { Cookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// import { openAlert } from "redux/slices/alertSlice";
// import { setScroll } from "redux/slices/scrollSlice";
import "lang/i18n";
import "css/common.css";
import { useMediaQuery } from "react-responsive";
import Platform from "pages/platform";
import SignUp from "pages/signup/signup";
import SignUpVerify from "pages/signup/signupVerify";
import SignUpDetail from "pages/signup/signupDetail";
import SignUpComplete from "pages/signup/signupComplete";
import SignUpExpired from "pages/signup/signupExpired";
import ScrollToTop from "component/common/scrollToTop";
import Wrapper from "component/template/wrapper";
import Header from "component/template/header";
import Body from "component/template/body";
import Footer from "component/template/footer";

function Root() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const [navLink, setNavLink] = useState("");

  const handleNavLink = (link) => {
    setNavLink(link);
  };
  const containerRef = useRef(null);
  //dispatch
  const dispatch = useDispatch();
  //cookie
  const cookies = new Cookies();
  //env
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const authNm = process.env.REACT_APP_AUTH_TOKEN;
  // const authTime = process.env.REACT_APP_AUTH_TOKEN_TIME;
  const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
  const domain = process.env.REACT_APP_DOMAIN;

  //set screen size
  const setScreenSize = useCallback(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    let prevVisualViewport = 0;
    const currentVisualViewportHeight = window.visualViewport.height;

    if (
      prevVisualViewport - 30 > currentVisualViewportHeight &&
      prevVisualViewport - 100 < currentVisualViewportHeight
    ) {
      const scrollHeight = window.document.scrollingElement.scrollHeight;
      const scrollTop = scrollHeight - window.visualViewport.height;

      window.scrollTo(0, scrollTop);
    }

    prevVisualViewport = window.visualViewport.height;

    window.visualViewport.onresize = prevVisualViewport;
  }, []);

  //resize eventListener
  useLayoutEffect(() => {
    setScreenSize();
    window.addEventListener("resize", () => setScreenSize());
  });

  // const inessentialList = [];
  // axios.defaults.url = serverUrl;
  // axios.defaults.baseURL = serverUrl;
  // axios.defaults.withCredentials = false;
  // //axios request
  // axios.interceptors.request.use(
  //   async (config) => {
  //     if (config.params == null) {
  //       config.params = {};
  //     }

  //     if (!inessentialList.includes(config.url)) {
  //       const authCookie = cookies.get(authNm);
  //       const refreshCookie = cookies.get(refreshNm);

  //       if (authCookie === undefined && refreshCookie === undefined) {
  //         cookies.remove(authNm, { path: "/", domain: domain });
  //         cookies.remove(refreshNm, { path: "/", domain: domain });
  //         window.location.href = process.env.REACT_APP_CLIENT_URL;
  //       }

  //       config.headers.Authorization = `Bearer ${authCookie}`;
  //       config.headers.RefreshAuthorization = `Bearer ${refreshCookie}`;
  //     }

  //     const authCookie = cookies.get(authNm);
  //     const refreshCookie = cookies.get(refreshNm);

  //     if (authCookie !== undefined && refreshCookie !== undefined) {
  //       config.headers.Authorization = `Bearer ${authCookie}`;
  //       config.headers.RefreshAuthorization = `Bearer ${refreshCookie}`;
  //     }

  //     return config;
  //   },
  //   (err) => {
  //     return Promise.reject(err);
  //   },
  // );

  // //axios response
  // axios.interceptors.response.use(
  //   (res) => {
  //     if (res.headers.refresh_authorization !== undefined) {
  //       cookies.remove(authNm, { path: "/", domain: domain });
  //       cookies.set(authNm, res.headers.refresh_authorization, {
  //         path: "/",
  //         domain: domain,
  //       });
  //     }

  //     return res;
  //   },
  //   (err) => {
  //     const response = err.response;

  //     if (response !== undefined) {
  //       const status = response.status;

  //       if (status === 400) {
  //         cookies.remove(authNm, { path: "/", domain: domain });
  //         cookies.remove(refreshNm, { path: "/", domain: domain });
  //       } else if (status === 401) {
  //         cookies.remove(authNm, { path: "/", domain: domain });
  //         cookies.remove(refreshNm, { path: "/", domain: domain });

  //         dispatch(
  //           openAlert({
  //             title: "Notice",
  //             content: err.response.data,
  //             submitEventHandler: () =>
  //               (window.location.href = process.env.REACT_APP_CLIENT_URL),
  //           }),
  //         );
  //       } else if (status === 404) {
  //         throw new Error("It is an unknown request.");
  //       }
  //     } else {
  //       dispatch(
  //         openAlert({
  //           title: "Error",
  //           content: err.code,
  //           submitEventHandler: () => {},
  //         }),
  //       );
  //     }

  //     return Promise.reject(err);
  //   },
  // );

  // useEffect(() => {
  //   const handleScroll = () => {
  //     dispatch(
  //       setScroll({
  //         scrollPosition: containerRef.current.scrollTop,
  //         scrollToTopHandler: () =>
  //           containerRef.current.scrollTo({ top: 0, left: 0 }),
  //       }),
  //     );
  //   };

  //   const container = containerRef.current;
  //   container.addEventListener("scroll", handleScroll);

  //   return () => {
  //     container.removeEventListener("scroll", handleScroll);
  //   };
  // }, [dispatch]);

  const scrollToTop = () => {
    containerRef.current.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setNavLink("");
  };

  const [isOpenNotice, setIsOpenNotice] = useState(true);
  return (
    <BrowserRouter>
      <div
        className="container"
        ref={containerRef}
      >
        {/* <button
          className="scroll_top_btn"
          onClick={() => scrollToTop()}
        >
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}img/common/top.webp`}
            alt=""
          />
        </button> */}
        {/* <ScrollToTop /> */}
        <Wrapper>
          <Header
            handleNavLink={handleNavLink}
            scrollToTop={scrollToTop}
            isOpenNotice={isOpenNotice}
            setIsOpenNotice={setIsOpenNotice}
          />
          <Body>
            <Routes>
              <Route
                path="/"
                element={
                  <Platform
                    link={navLink}
                    containerRef={containerRef}
                    isOpenNotice={isOpenNotice}
                  />
                }
              />
              <Route
                path="/signup"
                element={<SignUp />}
              />
              <Route
                path="/signup/verify"
                element={<SignUpVerify />}
              />
              <Route
                path="/signup/detail"
                element={<SignUpDetail />}
              />
              <Route
                path="/signup/complete"
                element={<SignUpComplete />}
              />
              <Route
                path="/signup/expired"
                element={<SignUpExpired />}
              />
              <Route
                path="*"
                element={
                  <Navigate
                    to="/"
                    replace
                  />
                }
              />
            </Routes>
          </Body>
          <Footer
            handleNavLink={handleNavLink}
            scrollToTop={scrollToTop}
          />
        </Wrapper>
      </div>
    </BrowserRouter>
  );
}

export default Root;
